import styles from "./OperatorsList.module.css";
import { Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as driverightActions from "../../../store/actions/driveright";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import NoData from "../../shared/ui/no-data/NoData";
import { baseTitle } from "../../../constants/messages";

function OperatorsList() {
  const history = useHistory();
  const dispatch = useDispatch();
  let policyNumber = useSelector(
    (state) => state.policies.activePolicy?.PolicyNumber
  );
  let operators = useSelector((state) => state.driveright.operators);
  let aysUrl = process.env.REACT_APP_AYS_URL;
  let agent = useSelector((state) => state.user.agentInfo);

  useEffect(() => {
    dispatch(driverightActions.getOperators(policyNumber));
  }, [dispatch, policyNumber]);

  useEffect(() => {
    document.title = baseTitle + " - DriveSteady Activation Code";
  }, []);

  const handleRowClick = (index) => {
    dispatch(driverightActions.setOperator(operators[index]));
    agent ? history.push("/questionnaire-a") : history.push("/questionnaire");
  };

  return (
    <>
      {operators?.length > 0 ? (
        <>
          <div className={styles.container}>
            <span className={styles.active}>
              Select an operator to send them a code
            </span>
          </div>
          <div className={styles.container}>
            <div className={styles.subcontainer}>
              {<span>Operators with DriveSteady</span>}
              <div className={styles.subtitle}>
                (**Only <span className={styles.emphasized}>one</span> operator
                can be selected at a time to have the activation code resent)
              </div>
            </div>
            <div className={styles.subcontainer}>
              <strong>Verify Operator Cell Phone Number:</strong>
              {agent ? (
                <>
                  <div className={styles.subtitle}>
                    NOTE: If cell phone number requires updating, please process
                    an amendment in the policy system
                  </div>
                  <a
                    href={`${aysUrl}/ays/PolicyChange/Index?pnum=${policyNumber}`}
                    className={styles.link}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Link to transaction history
                  </a>
                </>
              ) : (
                <div className={styles.subtitle}>
                  NOTE: If cell phone number requires updating, please contact
                  your agent.
                </div>
              )}
            </div>
          </div>
          <Table striped borderless hover>
            <tbody>
              {operators.map((operator, index) => {
                return (
                  <tr
                    key={index}
                    className={styles.row}
                    onClick={() => handleRowClick(index)}
                  >
                    <td className={styles.cell}>
                      {operator.FirstName} {operator.LastName}
                    </td>
                    <td
                      className={styles.cell}
                    >{`${operator.Cellphone.substring(
                      0,
                      3
                    )}-${operator.Cellphone.substring(
                      3,
                      6
                    )}-${operator.Cellphone.substring(6)}`}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </>
      ) : (
        <NoData message="NO OPERATORS" height="100%" />
      )}
    </>
  );
}

export default OperatorsList;
